const ORG_STOCK_OFF = 'Controle de estoque desativado na organização';
const REQUIRES_STOCK = 'Requer controle de estoque ativo';
const LOT_OFF = 'Controle de lote desativado na organização';
const LOT_MANDATORY = 'Controle de lote obrigatório na organização';
const EXPIRY_OFF = 'Rastreio de validade desativado na organização';
const REQUIRES_LOT = 'Requer controle de lote';
/**
 * Resolves effective product stock-control flags under the organization ceiling.
 * Pure — console and phase D both consume this; do not reimplement the cascade in UI.
 */
export function resolveProductStockControl(product, orgStockParams) {
    const orgEnabled = orgStockParams?.['stockControlEnabled'] === true;
    const lotControl = String(orgStockParams?.['lotControl'] ?? 'off');
    const expirationTracking = orgStockParams?.['expirationTracking'] === true;
    const disabled = {
        stockControlEnabled: false,
        stockControlByLot: false,
        stockHasExpiry: false,
        stockControlByVolume: false,
    };
    const reasons = {};
    let stockControlEnabled = product.stockControlEnabled === true;
    if (!orgEnabled) {
        stockControlEnabled = false;
        disabled.stockControlEnabled = true;
        reasons.stockControlEnabled = ORG_STOCK_OFF;
    }
    let stockControlByLot = product.stockControlByLot === true;
    let stockControlByVolume = product.stockControlByVolume === true;
    let stockHasExpiry = product.stockHasExpiry === true;
    if (!orgEnabled) {
        stockControlByLot = false;
        stockControlByVolume = false;
        stockHasExpiry = false;
        disabled.stockControlByLot = true;
        disabled.stockControlByVolume = true;
        disabled.stockHasExpiry = true;
        reasons.stockControlByLot = ORG_STOCK_OFF;
        reasons.stockControlByVolume = ORG_STOCK_OFF;
        reasons.stockHasExpiry = ORG_STOCK_OFF;
    }
    else if (!stockControlEnabled) {
        stockControlByLot = false;
        stockControlByVolume = false;
        stockHasExpiry = false;
        disabled.stockControlByLot = true;
        disabled.stockControlByVolume = true;
        disabled.stockHasExpiry = true;
        reasons.stockControlByLot = REQUIRES_STOCK;
        reasons.stockControlByVolume = REQUIRES_STOCK;
        reasons.stockHasExpiry = REQUIRES_STOCK;
    }
    else {
        // Volume — free under product stock enabled (no org param yet).
        stockControlByVolume = product.stockControlByVolume === true;
        if (lotControl === 'off') {
            stockControlByLot = false;
            disabled.stockControlByLot = true;
            reasons.stockControlByLot = LOT_OFF;
        }
        else if (lotControl === 'mandatory') {
            stockControlByLot = true;
            disabled.stockControlByLot = true;
            reasons.stockControlByLot = LOT_MANDATORY;
        }
        else {
            stockControlByLot = product.stockControlByLot === true;
        }
        if (!stockControlByLot) {
            stockHasExpiry = false;
            disabled.stockHasExpiry = true;
            reasons.stockHasExpiry = REQUIRES_LOT;
        }
        else if (!expirationTracking) {
            stockHasExpiry = false;
            disabled.stockHasExpiry = true;
            reasons.stockHasExpiry = EXPIRY_OFF;
        }
        else {
            stockHasExpiry = product.stockHasExpiry === true;
        }
    }
    return {
        values: {
            stockControlEnabled,
            stockControlByLot,
            stockHasExpiry,
            stockControlByVolume,
        },
        disabled,
        reasons,
    };
}
/**
 * Whether the product declares any variation axis — stock identity is then
 * `variantId`, otherwise plain `productId` (spec 0031 §3). Includes SIZE via
 * `sizeGridId` (0097).
 */
export function productDeclaresVariation(product) {
    if (product.productionVariationColor === true)
        return true;
    if (Array.isArray(product.acceptedVariationOptionIds) &&
        product.acceptedVariationOptionIds.length > 0) {
        return true;
    }
    if (typeof product.sizeGridId === 'string' && product.sizeGridId.trim() !== '') {
        return true;
    }
    return false;
}
//# sourceMappingURL=productStockControl.js.map